import authRequest from "../utils/authRequest";
import moment from "moment";

let prevSearchText = "";

export const getAllsettlement = (
    page: number,
    pageSize: number = 50,
    searchTexts?: any,
    filter?:any
): Promise<any> => {

    let currentPage = page;

    if (searchTexts && !prevSearchText) {
      currentPage = 1; 
    }

    prevSearchText = searchTexts || "";

    const clients = filter?.clients?.join(",") || "";
    const organizations = filter?.organizations?.join(",") || "";
    const settlement_status = filter?.settlement_status?.join(",") || "";
    const payment_status = filter?.payment_status?.join(",") || "";

    const start_date = filter?.dates?.[0]
        ? moment(filter.dates[0]).format("YYYY-MM-DD")
        : "";

    const end_date = filter?.dates?.[1]
        ? moment(filter.dates[1]).format("YYYY-MM-DD")
        : "";
    return new Promise((resolve, reject) => {
        authRequest({
        url:
            `/api/v1/settlement/all` +
            `?page=${currentPage}` +
            `&per_page=${pageSize}` +
            `&search_text=${searchTexts || ""}` +
            `&clients=${clients}` +
            `&organizations=${organizations}` +
            `&settlement_status=${settlement_status}` +
            `&payment_status=${payment_status}` +
            `&start_date=${start_date}` +
            `&end_date=${end_date}`,
        method: "get",
        })
        .then(({ data }) => resolve(data))
        .catch((err) => reject(err));
    });
};

export const getSchedulesettlement = (
    page: number,
    pageSize: number = 50,
): Promise<any> => {

    let currentPage = page;

    return new Promise((resolve, reject) => {
        authRequest({
        url:
            `/api/v1/settlement/get-schedule-settlement` +
            `?page=${currentPage}` +
            `&per_page=${pageSize}`,
        method: "get",
        })
        .then(({ data }) => resolve(data))
        .catch((err) => reject(err));
    });
};

export const startSettlement = (id: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        authRequest({
            url: `/api/v1/settlement/start-schedule-settlement/${id}`,
            method: "post",
        })
            .then(({ data }) => resolve(data))
            .catch((err) => reject(err));
    });
};

export const pauseSettlement = (id: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        authRequest({
            url: `/api/v1/settlement/pause-schedule-settlement/${id}`,
            method: "post",
        })
            .then(({ data }) => resolve(data))
            .catch((err) => reject(err));
    });
};

export const getScheduleSettlement = (id: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        authRequest({
            url: `/api/v1/settlement/get-schedule-settlement/${id}`,
            method: "get",
        })
            .then(({ data }) => resolve(data))
            .catch((err) => reject(err));
    });
};

export const deleteSettlement = (id: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        authRequest({
            url: `/api/v1/settlement/delete-schedule-settlement/${id}`,
            method: "post",
        })
            .then(({ data }) => resolve(data))
            .catch((err) => reject(err));
    });
};

export const getAllsettlementDashboard = (
  client_ids?: any,
  time_frame?: any,
  datesTop?: any
): Promise<any> => {

  const start_date =
    datesTop?.[0]
      ? datesTop[0].toISOString().substring(0, 10)
      : null;

  const end_date =
    datesTop?.[1]
      ? datesTop[1].toISOString().substring(0, 10)
      : null;

  const data = {
    client_ids,
    time_frame,
    start_date,
    end_date
  };

  return new Promise((resolve, reject) => {

    authRequest({
      url: `/api/v1/settlement/dashboard`,
      method: "post",
      data
    })
      .then(({ data }) => {
        resolve(data);
      })
      .catch((err) => {
        reject(err);
      });

  });
};


export const generateSettlementReport = (data: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        authRequest({
            url: "/api/v1/settlement/generate-report",
            method: "post",
            data,
        })
            .then(({ data }) => {
                resolve(data);
            })
            .catch((err) => {
                reject(err);
            });
    });
};

export const scheduleSettlement = (data: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        authRequest({
            url: "/api/v1/settlement/schedule-settlement",
            method: "post",
            data,
        })
            .then(({ data }) => {
                resolve(data);
            })
            .catch((err) => {
                reject(err);
            });
    });
};

export const updateScheduleSettlement = (data: any,id:any): Promise<any> => {
    return new Promise((resolve, reject) => {
        authRequest({
            url: "/api/v1/settlement/update-schedule-settlement/"+id,
            method: "post",
            data,
        })
            .then(({ data }) => {
                resolve(data);
            })
            .catch((err) => {
                reject(err);
            });
    });
};


export const deleteSettlementReport = (id: string): Promise<any> => {
    return new Promise((resolve, reject) => {
        authRequest({
            url: "/api/v1/settlement/delete-report/" + id,
            method: "delete",
        })
            .then(({ data }) => {
                resolve(data);
            })
            .catch((err) => {
                reject(err);
            });
    });
};

export const updateSettlementRecord = (data: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        authRequest({
            url: "/api/v1/settlement/edit-report/" + data?.id,
            method: "put",
            data,
        })
            .then(({ data }) => {
                resolve(data);
            })
            .catch((err) => {
                reject(err);
            });
    });
};


export const downloadSettlementReport = (settlement_id: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        authRequest({
            url: "/api/v1/settlement/generate-excel/" + settlement_id,
            method: "get",
            // params: params
        })
            .then(({ data }) => {
                resolve(data);
            })
            .catch((err) => {
                reject(err);
            });
    });
};

export const checkTransactionAvailableSettlementReport = (settlement_id: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        authRequest({
            url: "/api/v1/settlement/transaction_available/" + settlement_id,
            method: "get",
            // params: params
        })
            .then(({ data }) => {
                resolve(data);
            })
            .catch((err) => {
                reject(err);
            });
    });
};



export const DownloadCSVSettlement = (): Promise<any> => {
    return new Promise((resolve, reject) => {
        //   const data = `${clients?.length > 0 ? ('?clients=' + clients) : "?"}${interval?.length > 0 ? ('&interval=' + interval) : ""}${duration > 0 ? ('&duration=' + duration) : ""}${status?.length > 0 ? ('&status=' + status) : ""}`
        authRequest({
            url: "/api/v1/subscription/download-csv",
            method: "get",
        })
            .then(({ data }) => {
                resolve(data);
            })
            .catch((err) => {
                reject(err);
            });
    });
}



export const getClientPaymentMethodDetailsSettlement = (params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        authRequest({
            url: "/api/v1/settlement/clients-card-types",
            method: "get",
            params: params
        })
            .then(({ data }) => {
                resolve(data);
            })
            .catch((err) => {
                reject(err);
            });
    });
};


export const approvedSettlement = (data: any,id:any): Promise<any> => {
    return new Promise((resolve, reject) => {
        authRequest({
            url: "/api/v1/settlement/approved-settlement/"+id,
            method: "put",
            data,
        })
            .then(({ data }) => {
                resolve(data);
            })
            .catch((err) => {
                reject(err);
            });
    });
};